import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-pick',
  templateUrl: './data-pick.component.html',
  styleUrls: ['./data-pick.component.scss']
})
export class DataPickComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    const event = {
      href: window.location.href,
      search: window.location.search
    };
    window?.opener?.postMessage(event, '*');
  }
}
